const languagesEndpoints = {
  base: '/v1/cms/languages',
  byId: (id) => `/v1/cms/languages/${id}`
};

export default languagesEndpoints;
